import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ApiReportsResponse,
  GetUsersStatisticsResponse,
  UserData,
  UserDetailsData,
  UserDetailsStatsData,
} from '../../../types/reports';
import { baseQueryWithReauth } from '../baseQuery';

export const usersReportsService = createApi({
  reducerPath: 'usersReportsService',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getUsersStatistics: builder.query<GetUsersStatisticsResponse, void>({
      query: () => ({
        url: `/v1/profile-user/user-report/stats`,
      }),
    }),
    getUsers: builder.query<ApiReportsResponse<UserData>, string>({
      query: (params) => ({
        url: `v1/profile-user/user-report?${params}`,
      }),
    }),
    getUserById: builder.query<UserDetailsData, number>({
      query: (id) => ({
        url: `/v1/profile-user/user-report/profile-details/${id}`,
      }),
    }),
    getUserStats: builder.query<UserDetailsStatsData, number>({
      query: (id) => ({
        url: `/v1/profile-user/user-report/profile-details/${id}/stats`,
      }),
    }),
    exportUsers: builder.query<any, { params: string; format: string }>({
      query: ({ params, format }) => ({
        url: `/v1/profile-user/user-report/export-${format}?${params}`,
        responseHandler: async (response) => await response.blob(),
      }),
    }),
  }),
});

export const {
  useGetUsersStatisticsQuery,
  useGetUsersQuery,
  useGetUserByIdQuery,
  useGetUserStatsQuery,
  useLazyExportUsersQuery,
} = usersReportsService;
